import { SelectListOption } from "./common.type";
import { DayOfWeek, EmployeeType, PayrollType } from "./enums.type";

export interface OfficeDefaultRateDto {
  id: number;
  officeId: number;
  positionId: number;
  name: string;
  amount: number;
}

export interface OfficeDto {
  id: number;
  stripeCustomerId: string | null;
  officeName: string;
  practiceName: string;
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zipCode: string;
  phone: string | null;
  officePhone: string;
  emailAddress: string;
  website: string;
  image: string;
  practiceId: number;
  payroll: OfficePayrollDto | null;
  subscriptionStatus: number;
  hasConfirmedShift: boolean;
  isBillable: boolean;
  hours: OfficeHourDto[];
  users: OfficeUserDto[];
  rates: OfficeDefaultRateDto[];
}

export interface OfficeHourDto {
  officeId: number | null;
  dayOfWeek: DayOfWeek;
  openTime: string | null;
  closeTime: string | null;
  breakMinutes: string | null;
}

export interface OfficePayrollDto {
  id: number;
  officeId: number;
  employeeType: EmployeeType;
  type: PayrollType;
  description: string | null;
}

export interface OfficeUserDto {
  userId: number;
  officeId: number | null;
  userEmail: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  officeUserStatus: number | null;
  roleName: string;
  initials: string;
  fullName: string;
}

export interface OfficeProfileDto {
  id: number;
  stripeCustomerId: string | null;
  practiceId: number;
  practiceName: string;
  officeName: string;
  emailAddress: string;
  phone: string | null;
  officePhone: string;
  website: string;
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zipCode: string;
  disabled: boolean;
  hours: OfficeHourDto[];
  users: OfficeUserDto[];
  rates: OfficeDefaultRateDto[];
  payroll: OfficePayrollDto | null;
  subscriptionStatus: number;
  isSubscriptionCancelled: boolean;
  isBillable: boolean;
}

export interface OfficeDataDto {
  statuses: SelectListOption[];
  subscriptionStatuses: SelectListOption[];
}

export class OfficeUserFormDto {
  userId = 0;
  officeId = 0;
  status = 0;
}

export class OfficePayrollFormDto {
  id: number | null = null;
  officeId = 0;
  employeeType = EmployeeType.OneZeroNineNine;
  type = PayrollType.Biweekly;
  description: string | null = null;
}

export class OfficeHourFormDto {
  officeId = 0;
  sundayOpenTime: string | null = null;
  sundayCloseTime: string | null = null;
  sundayBreakMinutes: number | null = null;
  mondayOpenTime: string | null = null;
  mondayCloseTime: string | null = null;
  mondayBreakMinutes: number | null = null;
  tuesdayOpenTime: string | null = null;
  tuesdayCloseTime: string | null = null;
  tuesdayBreakMinutes: number | null = null;
  wednesdayOpenTime: string | null = null;
  wednesdayCloseTime: string | null = null;
  wednesdayBreakMinutes: number | null = null;
  thursdayOpenTime: string | null = null;
  thursdayCloseTime: string | null = null;
  thursdayBreakMinutes: number | null = null;
  fridayOpenTime: string | null = null;
  fridayCloseTime: string | null = null;
  fridayBreakMinutes: number | null = null;
  saturdayOpenTime: string | null = null;
  saturdayCloseTime: string | null = null;
  saturdayBreakMinutes: number | null = null;
}

export class OfficeFormDto {
  practiceId: number | null = null;
  officeId: number | null = null;
  officeName = "";
  address1 = "";
  address2: string | null = null;
  city = "";
  state = "";
  zipCode = "";
  phone: string | null = null;
  officePhone = "";
  emailAddress = "";
  website = "";
}

export class OfficeDefaultRateFormsDto {
  rates: OfficeDefaultRateFormDto[] = [];
}

export class OfficeDefaultRateFormDto {
  id: number | null = null;
  positionId = 0;
  officeId = 0;
  amount = 0;
  positionName?: string;
}

export class OfficeStatusFormDto {
  id: number = 0;
  statusId: number = 0;
}
